// TODO: дальше импорты не из src/shared/components/desktop, потому что там в индексном файле подтягивается fetch,
//  который подтягивает superagent, который ломает сборку в SSR. Когда superagent заменим на что-то другое,
//  необходимость рендерить отдельный Header в /public отпадет и константы отсюда можно будет вернуть в <Header />
import ConnectionMethodsMenu from 'src/shared/components/header-menu/ConnectionsMethodsMenu'
import OtherBusinessesMenu from 'src/shared/components/header-menu/OtherBusinessMenu'
import ServicesMenu from 'src/shared/components/header-menu/ServicesMenu'
import ServicesMenuMobile from 'src/shared/components/header-mobile-menu/ServicesMenu'
import {i18n} from 'src/shared/config'

import * as classes from '../classes'

export const controlPanel = [
  {
    button: {
      label: i18n('order.header.button.become-a-courier', 'Стать курьером'),
    },
    list: [
      {
        href: '/for-courier/',
        label: i18n(
          'order.header.button.on-foot-or-by-auto-courier',
          'Пешим или автокурьером',
        ),
      },
      {
        href: '/for-driver/personal-cargo/',
        label: i18n(
          'order.header.button.truck-driver',
          'Водителем грузовой машины',
        ),
      },
    ],
  },
]

export const linksList = [
  {
    label: i18n('order.header.link.services', 'Услуги'),
    content: (
      <div className={classes.servicesMenu}>
        <ServicesMenu />
      </div>
    ),
  },
  {
    label: i18n(
      'order.header.link.for-different-businesses',
      'Для разных бизнесов',
    ),
    content: (
      <div className={classes.otherBusinessesMenu}>
        <OtherBusinessesMenu />
      </div>
    ),
  },
  {
    label: i18n('order.header.link.connection-methods', 'Способы подключения'),
    content: (
      <div className={classes.connectionMethodsMenu}>
        <ConnectionMethodsMenu />
      </div>
    ),
  },
]

export const linksListMobile = [
  {
    id: 'main',
    passOnClick: true,
    list: [
      {id: 'services', label: i18n('order.header.link.services', 'Услуги')},
      {
        id: 'different-businesses',
        label: i18n(
          'order.header.link.for-different-businesses',
          'Для разных бизнесов',
        ),
      },
      {
        id: 'connection-methods',
        label: i18n(
          'order.header.link.connection-methods',
          'Способы подключения',
        ),
      },
      {
        id: 'become-a-courier',
        label: i18n('order.header.button.become-a-courier', 'Стать курьером'),
      },
    ],
  },
  {
    id: 'services',
    content: <ServicesMenuMobile />,
  },
  {
    id: 'connection-methods',
    list: [
      {
        label: i18n('order.header.link.personal-area', 'Личный кабинет'),
        href: 'https://passport.yandex.ru/auth/reg?retpath=https%3A%2F%2Fdostavka.yandex.ru%2Faccount2%3Foffer%3Dtrue&origin=dostavka',
      },
      {
        label: i18n(
          'order.header.link.yandex-go-application',
          'Приложение Яндекс Go',
        ),
        href: '/business/small/',
      },
      {
        label: i18n('order.header.link.api-integration', 'API-интеграция'),
        href: '/integrations/api/',
      },
      {
        label: i18n(
          'order.header.link.restaurant-modules',
          'Модули для ресторанов',
        ),
        href: '/integrations/restaurants/',
      },
      {
        label: i18n(
          'order.header.link.internet-shop-modules',
          'Модули для интернет-магазинов',
        ),
        href: '/integrations/ecommerce/',
      },
    ],
  },
  {
    id: 'different-businesses',
    list: [
      {
        label: i18n(
          'order.header.link.restaurants-and-caffe',
          'Рестораны и кафе',
        ),
        href: '/business/restaurants/',
      },
      {
        label: i18n('order.header.link.internet-shops', 'Интернет-магазины'),
        href: '/business/ecommerce/',
      },
      {
        label: i18n('order.header.link.cosmetics', 'Косметика'),
        href: '/business/cosmetics/',
      },
      {
        label: i18n('order.header.link.flowers', 'Цветы'),
        href: '/business/flowers/',
      },
      {
        label: i18n('order.header.link.child', 'Детские товары'),
        href: '/business/children-goods/',
      },
      {
        label: i18n('order.header.link.pets', 'Товары для животных'),
        href: '/business/pet-supplies/',
      },
      {
        label: i18n('order.header.link.spare-parts', 'Автозапчасти'),
        href: '/business/auto-parts/',
      },
      {
        label: i18n('order.header.link.electronic', 'Электроника'),
        href: '/business/appliances/',
      },
      {
        label: i18n('order.header.link.sport', 'Спорттовары'),
        href: '/business/sport-goods/',
      },
    ],
  },
  {
    id: 'become-a-courier',
    list: controlPanel[0].list,
  },
]
